import { connect } from 'react-redux';

import AuthLayout from '../layouts/Auth/authLayout';
import { verifyLoggedUser } from '../utils/verifyUserLogged';

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  verifyLoggedUser: () => verifyLoggedUser(),
});

const AuthContainer = connect(mapStateToProps, mapDispatchToProps)(AuthLayout);

export default AuthContainer;
